'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable');
module.exports = function CognitoModel(authenticationModel, cognitoAuthenticator, cognitoApi) {
	const self = observable(this),
		getContext = function (profile) {
			if (profile && profile.provider === cognitoAuthenticator.providerName()) {
				return cognitoApi.getUserActions().then(result => Object({
					canSetPassword: result.includes('SET_PASSWORD'),
					canChangePassword: result.includes('CHANGE_PASSWORD')
				}));
			} else {
				return Promise.resolve({});
			}
		},
		sendContext = function (profile) {
			getContext(profile)
			.then(context => self.dispatchEvent('context', context));
		};

	if (!authenticationModel || !cognitoAuthenticator || !cognitoApi) {
		throw 'invalid-args';
	}

	authenticationModel.addEventListener('authenticatedProfile', sendContext);

	authenticationModel.addEventListener('not-authenticated', () => self.dispatchEvent('context', {}));

	self.sendContext = function () {
		authenticationModel.getProfile().then(sendContext);
	};

};
